// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"0ee5efc1","899":"8560f8d9"}[chunkId] + ".chunk.css";
};